export default __webpack_public_path__ + "static/media/Wordpress_DeLoach_Ministries_2_Empower_U.edebaa08.png";